var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('base-header')],1),_c('v-content',{staticClass:"mt-2",class:_vm.breakpoint.smAndDown ? 'backgroundMobile mb-5' : 'backgroundDesktop'},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }